import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "9",
  height: "10",
  viewBox: "0 0 9 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8 3.268c1.333.77 1.333 2.694 0 3.464L3.5 9.33c-1.333.77-3-.192-3-1.732V2.402C.5.862 2.167-.1 3.5.67L8 3.268Z",
      fill: "#FFC534"
    }, null, -1)
  ]))]))
}
export default { render: render }